const COLUMN_TYPE_RECOMMENDATION = {
  DEFAULT: "DEFAULT",
  DRAWER: "DRAWER",
};

const CALL_TYPE_QUEUE = {
  CURRENT: "CURRENT",
  NEXT: "NEXT",
};

export {
  COLUMN_TYPE_RECOMMENDATION,
  CALL_TYPE_QUEUE,
};
